import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment'

import {
    logar_signatario
} from '../../actions'

class Auth extends Component{
    constructor(){
        super()
        this.state = {
            cpfCnpj: '',
            dataNasc: '',
            nome: '',
            id: undefined // id do documento
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.logar = this.logar.bind(this);
    }

    componentWillMount(){
        if(this.props.match.params.id != undefined) this.setState({id: this.props.match.params.id})
    }

    handleInputChange(event){
        let name = event.target.name
        let val = event.target.value
        if (name == 'dataNasc') val = moment(val).format('DD/MM/YYYY')
        this.setState({[name]:val})
    }

    logar(event){
        event.preventDefault()
        for(let i in this.state) if( this.state[i] == undefined || this.state[i].trim() == '') return alert('Preencha todos os campos.')
        
        this.props.logar_signatario(this.state)
    }

    render(){
        const { login_sig, error_sig_auth } = this.props.auth

        return(
            <div className="principal" style={{width: '100%', marginTop:0,display:'flex'}}>
                <form className="form-signin" onSubmit={this.logar}>
                    <img className="mb-4" src="/assets/imagem/logo.png" alt="" width="100" height="100" />
                    <h1 className="h3 mb-3 font-weight-normal">Seja bem vindo</h1>
                    
                    <div className="form-group">
                        <label  className="sr-only">CPF/CNPJ</label>
                        <input name="cpfCnpj" type="text" id="inputEmail" className="form-control" placeholder="CPF/CPNJ" required  onChange={this.handleInputChange} />                   
                    </div>

                    <div className="form-group">
                        <label  className="sr-only">Nome</label>
                        <input name="nome" type="text" id="inputPassword" className="form-control" placeholder="Nome" required onChange={this.handleInputChange} />
                    </div>
                    
                    <div className="form-group">
                        <label  className="sr-only">Data Nascimento</label>
                        <input name="dataNasc" type="date" id="inputPassword" className="form-control" required onChange={this.handleInputChange} />
                    </div>
        
                    <button className="btn btn-lg btn-primary btn-block" type="submit" role="button" disabled={login_sig}>
                        {login_sig ?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                        {login_sig ? '   Aguarde...' : 'Entrar'}
                    </button>

                    
                    {error_sig_auth != ''
                        ?<div className="alert alert-danger" role="alert" style={{marginTop:'5%'}}>
                            {error_sig_auth}
                        </div>
                        :null
                    }
                    <p className="mt-5 mb-3 text-muted">&copy; RBMWEB 2019</p>
                </form>
            </div>
       )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        auth
    }
}

export default connect(mapStateToProps, {
    logar_signatario
})(Auth);